let keeper;
/**
 * Sets the rule that keeps the camera on in the background. The native
 * media middleware sets it (middleware.native.ts). The web has none, so the
 * camera turns off in the background as before.
 *
 * @param {Function|undefined} next - The rule, or none.
 * @returns {void}
 */
export function setBackgroundCameraKeeper(next) {
    keeper = next;
}
/**
 * Whether the camera stays on now that the app goes to the background.
 *
 * @param {IReduxState} state - The redux state.
 * @returns {boolean}
 */
export function keepsCameraInBackground(state) {
    return Boolean(keeper?.(state));
}
/**
 * Robert, 2026-10-07: the camera stays on in the iOS system window of a call
 * (picture-in-picture), on iOS 18 and later. There an app with the voip
 * background mode that links against iOS 18 or later can use the camera
 * while multitasking without the multitasking camera entitlement (Apple,
 * AVCaptureSession.isMultitaskingCameraAccessSupported). On iOS 16 and 17
 * the entitlement is necessary, so the camera turns off there, and on Android,
 * as before.
 *
 * @param {Object} options - The inputs.
 * @param {boolean} options.flagEnabled - The pip.enabled feature flag.
 * @param {boolean} options.hasPipVideo - A remote video view holds the window,
 * so the window opens when the app goes to the background.
 * Robert, 2026-10-12: his video still froze in the window. Apple also says
 * that apps with a deployment target earlier than iOS 16 (this app: 15.1)
 * need the entitlement. So the system's own answer decides when the build
 * has it (ios/sdk/src/VRSCallCamera.m, multitaskingCameraSupported); the iOS
 * version is only the fallback for a build without it.
 *
 * @param {string} options.os - Platform.OS.
 * @param {string|number} options.osVersion - Platform.Version.
 * @param {boolean} [options.multitaskingSupported] - The system's answer, if known.
 * @returns {boolean}
 */
export function keepsCameraInSystemPip({ flagEnabled, hasPipVideo, multitaskingSupported, os, osVersion }) {
    if (os !== 'ios' || !flagEnabled || !hasPipVideo) {
        return false;
    }
    if (typeof multitaskingSupported === 'boolean') {
        return multitaskingSupported;
    }
    const major = parseInt(String(osVersion), 10);
    return Number.isFinite(major) && major >= 18;
}
